// @tennis-matches/services/masterdata/contact-source

export const CLUB_PERSON_CONTACT_SOURCE_TRAINER = "trainer";
export const CLUB_PERSON_CONTACT_SOURCE_BILLING = "billing_contact";
export const CLUB_PERSON_CONTACT_SOURCE_VENDOR = "vendor";

/**
 * @param {unknown} person club_people row
 */
export function isTrainerMirrorClubPerson(person) {
  return (
    String(person?.contact_source || "").trim() ===
    CLUB_PERSON_CONTACT_SOURCE_TRAINER
  );
}

/**
 * @param {unknown} person club_people row
 */
export function isBillingMirrorClubPerson(person) {
  return (
    String(person?.contact_source || "").trim() ===
    CLUB_PERSON_CONTACT_SOURCE_BILLING
  );
}

/**
 * @param {unknown} person club_people row
 */
export function isVendorClubPerson(person) {
  return (
    String(person?.contact_source || "").trim() ===
    CLUB_PERSON_CONTACT_SOURCE_VENDOR
  );
}

/**
 * @param {string} trainerId
 * @returns {string}
 */
export function buildTrainerstundenStammdatenEditHref(trainerId) {
  const tid = String(trainerId || "").trim();
  if (!tid) return "/trainingsdesk/stammdaten/trainer";
  return `/trainingsdesk/stammdaten/trainer?trainer=${encodeURIComponent(tid)}`;
}

/**
 * @param {{ personId?: string, newContact?: boolean, edit?: boolean }} [options]
 * @returns {string}
 */
export function buildTrainerstundenStammdatenContactsHref({
  personId = "",
  newContact = false,
  edit = false,
} = {}) {
  const base = "/trainingsdesk/kontakte";
  if (newContact) return `${base}?newContact=1`;
  const pid = String(personId || "").trim();
  if (!pid) return base;
  const sp = new URLSearchParams();
  sp.set("person", pid);
  if (edit) sp.set("edit", "1");
  return `${base}?${sp.toString()}`;
}
